<template>
    <q-page class="row">
        <!-- Modal de seja bem vindo -->
        <q-modal :maximized="false" v-model="showWelcome" :content-css="{minWidth: '60%', height: '30vh'}">
            <q-modal-layout footer-style="{textAlign: 'right'}">
                <q-toolbar color="primary" inverted slot="header">
                    <q-toolbar-title />
                    <q-btn flat round dense v-close-overlay @click="closeWelcome()" icon="close"/>
                </q-toolbar>
                <div class="modal-body layout-padding">
                    <div class="row">
                        <div class="col-12">
                            <h3 color="primary" style="font-size: 1.5em; text-align: center">{{ welcome.title }}</h3><br>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12" style="line-height: normal">
                            <div class="caption" style="text-align: center; line-height: normal" v-html="welcome.description"/>
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>
        <!-- Modal de seja bem vindo -->
        <div class="col-12" :class="{ 'row items-center justify-center': centered, 'layout-padding': padding }" @click="yourClickHandler">
            <slot></slot>
        </div>
    </q-page>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {loadMessages} from '../plugins/i18n'
    import {QPage, QModalLayout, QModal, QBtn, QToolbarTitle, QToolbar, Cookies} from 'quasar-framework'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'Page',

        data: () => ({
            appName: window.config.appName,
            welcome: {
                title: '',
                description: ''
            },
            showWelcome: false
        }),

        props: {
            padding: Boolean,
            centered: Boolean,
        },

        components: {
            QPage,
            QModalLayout,
            QModal,
            QBtn,
            QToolbarTitle,
            QToolbar
        },

        computed: {
            ...mapGetters({
                locale: 'lang/locale',
                locales: 'lang/locales',
                user: "auth/user"
            }),

            menus() {
                return window.config.menus
            }
        },
        created() {
          window.addEventListener('beforeunload', this.$watchUser('closed'))
        },
        mounted() {
            this.$loginCallback()
            localStorage.setItem(document.location.pathname, moment(document.lastModified).format('YYYY-MM-DD HH:mm:ss'))
            this.showWelcomeModal()
        },
        beforeDestroy() {
            this.$watchUser('redirect')
        },
        methods: {
            yourClickHandler(event) {
                let clickNow = {
                    'data': Array(event.target.outerHTML),
                    'date': moment(document.lastModified).format('YYYY-MM-DD HH:mm:ss')
                }
                let parsed = JSON.stringify(clickNow)
                localStorage.setItem('click', parsed)
                if (!localStorage.getItem('item'))
                    this.$watchUser('click')
            },
            setLocale(locale) {
              this.$q.i18n.rtl=false;
              if (this.$i18n.locale !== locale) {
                loadMessages(locale)

                this.$store.dispatch('lang/setLocale', {locale})
                this.$q.i18n.rtl = false;
              }
            },
            showWelcomeModal() {
                let user_status = this.user ? this.user.subscription_status : 0
                let portal_base = Cookies.get('portal')
                if(localStorage.getItem('newsub')) {
                    axios.get(`${config.appUrl}/${portal_base}/${user_status}/message?lang=${this.locale}`)
                      .then(response => {
                        this.welcome = response.data[0]
                      })
                      .finally(() => {
                        if (this.welcome.title !== ''){
                            this.showWelcome = true
                            setTimeout(function(){ this.closeWelcome() }.bind(this), 5000)
                        }
                      })
                }
            },
            closeWelcome() {
                this.showWelcome = false
            }
        },
        watch: {
            showWelcome: function(value) {
                if(!value) {
                    localStorage.removeItem('newsub')
                    this.$router.replace({query: {}})
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Page.vue